<!-- Custom Kossaya Update Banner -->
<div *ngIf="updateAvailable" style="position: fixed; top: 0; left: 0; right: 0; z-index: 99999; background: linear-gradient(135deg, #3AAFA9, #2B7A78); color: white; padding: 12px 16px; box-shadow: 0 4px 12px rgba(43, 122, 120, 0.3); display: flex; align-items: center; justify-content: space-between; gap: 16px; font-family: 'Inter', sans-serif; animation: slideDown 0.3s ease-out;">
    <div style="display: flex; align-items: center; gap: 12px;">
        <div style="background: rgba(255,255,255,0.2); width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 2v6h-6"></path>
                <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                <path d="M3 22v-6h6"></path>
                <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
            </svg>
        </div>
        <div>
            <div style="font-weight: 700; font-size: 14px; margin-bottom: 2px;">Versi Baru Tersedia</div>
            <div style="font-size: 12px; opacity: 0.9;">Muat ulang untuk menerapkan pembaruan.</div>
        </div>
    </div>
    <button (click)="reloadApp()" style="background: white; color: #2B7A78; border: none; padding: 8px 16px; border-radius: 8px; font-weight: 700; font-size: 13px; cursor: pointer; white-space: nowrap; box-shadow: 0 2px 6px rgba(0,0,0,0.1); transition: all 0.2s;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        Muat Ulang
    </button>
</div>

<style>
@keyframes slideDown {
    from { transform: translateY(-100%); }
    to { transform: translateY(0); }
}
</style>

<router-outlet></router-outlet>
